module.exports = __webpack_public_path__ + "img/GoExamplenolgo-min.d2e21d18.png";